export class Menu {
    constructor(public id: number,
                public title: string,
                public routerLink: string,
                public icon: string,
                public codigo: string) {}
}


// WEBPACK FOOTER //
// ./src/app/layout/sidenav/menu/menu.model.ts